import MobileFloatingActionButton from "../../../../../../../pages/FloatingItems/MobileFloatingActionButton";
import BeAwareTabs from "./BeAwareMobileContent/BeAwareTabs";

const BeAware = () => {
  return (
    <>
      <BeAwareTabs />
      <MobileFloatingActionButton trackerDataId="866" saveTrackerDataId="867" />
    </>
  );
};

export default BeAware;
